import * as _cycleStreets from './cycleStreets';
import * as _opendata from './opendata';
import * as _rm from './rm';
import * as _wp from './wp';

export const cycleStreets = _cycleStreets;
export const opendata = _opendata;
export const rm = _rm;
export const wp = _wp;



// WEBPACK FOOTER //
// ./src/services/index.js